import ProductDescription from './ProductDescription'

const PlantYogurtProduct = {
  ...ProductDescription,
  category: '00',
  subCategory: '001',
  IsBroadband: false,
  VitaminD: '',
  SweetenerCertification: false,
  Sugar: '',
  SugarCertification: false,
  Calcium: '',
  CalciumCertification: false,
  Protein: '',
  ProteinCertification: false,
  PlantYogurtAltType: '',
  OtherPlantYogurtAltType: null,
  Size: '',
  FatLevel: '',
  Flavor: '',
  OtherFlavor: null,
  MultiPackageType: false,
  MultiPackageCount: null,
}

export default PlantYogurtProduct
